import React from "react";
import "./App.css";
import Individual from "./components/Individual";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="overflow-x-hidden">
      <ToastContainer />
      <Individual />
    </div>
  );
}

export default App;
